"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _widgets = require("../../../../components/widgets");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var GroupFilters = /*#__PURE__*/function (_React$Component) {
  _inherits(GroupFilters, _React$Component);

  function GroupFilters() {
    _classCallCheck(this, GroupFilters);

    return _possibleConstructorReturn(this, _getPrototypeOf(GroupFilters).apply(this, arguments));
  }

  _createClass(GroupFilters, [{
    key: "render",
    value: function render() {
      var group = this.props.group;
      var filter = group.filter;
      var details = [{
        label: "Filter type",
        value: group.filterType == "conditions" ? "Custom filter" : "Specific users"
      }];

      if (filter.createdFrom) {
        details.push({
          label: "Registered from",
          value: filter.createdFrom
        });
      }

      if (filter.createdTo) {
        details.push({
          label: "Registered to",
          value: filter.createdTo
        });
      }

      if (filter.registeredBefore) {
        details.push({
          label: "Registered before x days or less",
          value: filter.registeredBefore
        });
      }

      if (filter.lastActivityFrom) {
        details.push({
          label: "Last activity from",
          value: filter.lastActivityFrom
        });
      }

      if (filter.lastActivityTo) {
        details.push({
          label: "Last activity to",
          value: filter.lastActivityTo
        });
      }

      if (filter.lastTransactionFrom) {
        details.push({
          label: "Last transaction date from",
          value: filter.lastTransactionFrom
        });
      }

      if (filter.lastTransactionTo) {
        details.push({
          label: "Last transaction date to",
          value: filter.lastTransactionTo
        });
      }

      if (filter.balanceFrom) {
        details.push({
          label: "Balance from",
          value: filter.balanceFrom
        });
      }

      if (filter.balanceTo) {
        details.push({
          label: "Balance to",
          value: filter.balanceTo
        });
      }

      if (filter.cardNotOrdered) {
        details.push({
          label: "Card not ordered",
          value: filter.cardNotOrdered ? "true" : "false"
        });
      }

      if (filter.cardNotActivated) {
        details.push({
          label: "Card not activated",
          value: filter.cardNotActivated ? "true" : "false"
        });
      }

      return _react["default"].createElement(_widgets.AppInfoList, {
        items: details
      });
    }
  }]);

  return GroupFilters;
}(_react["default"].Component);

exports["default"] = GroupFilters;